export function weightEntriesOf(signalSet) {
  if (
    signalSet?.weights &&
    typeof signalSet.weights === "object" &&
    !Array.isArray(signalSet.weights)
  ) {
    return Object.entries(signalSet.weights).map(([symbol, weight]) => ({
      symbol: String(symbol).toUpperCase(),
      weight: Number(weight) || 0,
    }));
  }
  const keys = signalSet?.weights_keys;
  const values = signalSet?.weights_values;
  if (!keys || !values) return [];
  return Object.keys(values)
    .map((key) => {
      const ticker = keys[key];
      if (!ticker?.symbol) return null;
      return {
        symbol: String(ticker.symbol).toUpperCase(),
        weight: Number(values[key]) || 0,
      };
    })
    .filter(Boolean);
}

export function toLegacyWeights(signalSet) {
  if (signalSet?.weights_keys && signalSet?.weights_values) {
    return {
      weights_keys: signalSet.weights_keys,
      weights_values: signalSet.weights_values,
    };
  }
  const weights_keys = {};
  const weights_values = {};
  weightEntriesOf(signalSet).forEach(({ symbol, weight }) => {
    weights_keys[symbol] = { symbol };
    weights_values[symbol] = weight;
  });
  return { weights_keys, weights_values };
}
